import { useCallback, useEffect, useState } from 'react'

import { ApiError, businessCategoriesApi, type PublicBusinessCategory } from '@/api'
import type { BusinessModuleKey } from '@/api/businessCategories'

export type { BusinessModuleKey }

function dedupeBusinessCategories(items: PublicBusinessCategory[]): PublicBusinessCategory[] {
  const seen = new Set<string>()
  const out: PublicBusinessCategory[] = []
  for (const item of items) {
    const key = `${item.module}:${item.code}`
    if (seen.has(key)) continue
    seen.add(key)
    out.push(item)
  }
  return out
}

export function useBusinessCategories(module: BusinessModuleKey) {
  const [items, setItems] = useState<PublicBusinessCategory[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const res = await businessCategoriesApi.listAll(module)
      setItems(dedupeBusinessCategories(res))
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : (err as Error).message
      setItems([])
      setError(msg)
    } finally {
      setLoading(false)
    }
  }, [module])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { items, loading, error, refresh }
}
